import { QualifyHeader } from "./QualifyHeader";
export default QualifyHeader;
